/** The Shopify install redirect: /integrations?shopify=installed (the #claim= fragment is stripped at boot). */
export function isShopifyClaimLandingUrl(loc: Pick<Location, 'pathname' | 'search' | 'hash'> = window.location): boolean {
  if (loc.pathname !== '/integrations') return false;
  return new URLSearchParams(loc.search).get('shopify') === 'installed' || loc.hash.includes('claim=');
}
